define([
    './ViewModelService',
    'edge/platform/metamirror/module'
], (ViewModelService)=> {
    return angular.module('edge.platform.viewmodel', ['edge.platform.metamirror'])
        .factory('ViewModelService', ViewModelService);
});


/** WEBPACK FOOTER **
 ** ./common/js/src/edge/platform/viewmodel/module.js
 **/